module.exports = __webpack_public_path__ + "img/cifras-experiencia.74181d32.webp";